import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import Modal from "react-modal";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import HelmetWrapper from "../../../HelmetWrapper";
import PageHeadingNew from "../../common-components/custom-comps/PageHeadingNew";
import {
  fetchThreeDayPTMembersStatsData,
  fetchThreeDayPTTrialData,
} from "../../../redux/plans-reducers/plansSlice";
import ThreeDayPTMembers from "./ThreeDayPTMembers";
import TrialAssignForm from "./TrialAssignForm";
import ThreedayTrialHistory from "./ThreedayTrialHistory";
import CmnFilters from "../../lead-management/common/CmnFilters";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import ThreeDayMemberDetailsTab from "./ThreeDayMemberDetailsTab";
import TrainerTrialReport from "./TrainerTrialReport";
import ThreeDayTrialStats from "./ThreeDayTrialStats";
import { isManagerRole as checkIsManagerRole } from "../../common-data/Conversions";

const ThreeDayPTTrialStructure = ({ userInfoData }) => {
  const dispatch = useDispatch();
  const { threeDayPTTrialLoading } = useSelector((state) => state.plans);

  const isAdmin = userInfoData?.account_type === "admin";
  const isGym = userInfoData?.account_type === "gym";
  const isMarketing = userInfoData?.account_type === "marketing";
  const isManagerRole = checkIsManagerRole(userInfoData);

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(5);
  const iniAllFilter = {
    selectedGym:
      !isAdmin && !isMarketing && !isManagerRole
        ? {
            label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
            value:
              userInfoData?.gym_id ||
              userInfoData?.user_id ||
              userInfoData?.uid ||
              "",
          }
        : "",
    selectedTrainer: "",
    selectedBCAStatus: "",
    selectedAssignedStatus: "",
    selectedDayNo: "",
    selectedCompletedCount: "",
    selectedSlotTime: "",
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    gym_id: allFilters.selectedGym?.value || "",
    trainer_id: allFilters.selectedTrainer?.value || "",
    bca_report_status: allFilters.selectedBCAStatus?.value || "",
    three_day_assigned: allFilters.selectedAssignedStatus?.value || "",
    day_no: allFilters.selectedDayNo?.value || "",
    completed_count: allFilters.selectedCompletedCount?.value || "",
    slot_time: allFilters.selectedSlotTime?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const iniModValues = {
    isModOpen: false,
    modName: "",
    rowData: null,
    selectedRows: [],
  };
  const [modValues, setModValues] = useState(iniModValues);

  const onCloseModal = () => {
    setModValues(iniModValues);
  };

  const onResetFilters = () => {
    setAllFilters({
      ...iniAllFilter,
      selectedBCAStatus: "",
      selectedAssignedStatus: "",
      selectedDayNo: "",
      selectedCompletedCount: "",
      selectedSlotTime: "",
    });
  };

  const onClickSearch = () => {
    setIsPage(0);

    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  function getThreeDayTrialMembers(filters) {
    dispatch(
      fetchThreeDayPTTrialData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  const getStats = (filters) => {
    const { page, limit, ...rest } = filters;

    dispatch(
      fetchThreeDayPTMembersStatsData({
        filters: rest,
        token: userInfoData?.token,
      })
    );
  };

  useEffect(() => {
    getStats(filters);
    getThreeDayTrialMembers(filters);
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      gym_id: allFilters.selectedGym?.value || "",
      trainer_id: allFilters.selectedTrainer?.value || "",
      bca_report_status: allFilters.selectedBCAStatus?.value || "",
      three_day_assigned: allFilters.selectedAssignedStatus?.value || "",
      day_no: allFilters.selectedDayNo?.value || "",
      completed_count: allFilters.selectedCompletedCount?.value || "",
      slot_time: allFilters.selectedSlotTime?.value || "",
    }));
  }, [
    isPage,
    pageLimit,
    allFilters.selectedGym,
    allFilters.selectedTrainer,
    allFilters.selectedBCAStatus,
    allFilters.selectedAssignedStatus,
    allFilters.selectedDayNo,
    allFilters.selectedCompletedCount,
    allFilters.selectedSlotTime,
  ]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  return (
    <HelmetWrapper title="WTF: 3 Day PT Trial">
      <Container className="bg-cloud-k px-50px" fluid>
        <Modal
          isOpen={modValues.isModOpen}
          onRequestClose={onCloseModal}
          contentLabel="Detail Modal"
          ariaHideApp={false}
        >
          <div
            className={`createNewCTOModalContainer ${
              modValues.modName === "trial_history"
                ? "mod-width-95p"
                : "mod-width-50p"
            } mod-height-95vh`}
          >
            {modValues.modName === "trial_history" ? (
              <ModalHeadAndClose
                title={modValues.rowData?.user_name || ""}
                onClose={onCloseModal}
              />
            ) : null}

            {modValues.modName === "trial_assign" ? (
              <TrialAssignForm
                rowData={modValues.rowData}
                closeModal={onCloseModal}
                userInfoData={userInfoData}
                callFunction={() => getThreeDayTrialMembers(filters)}
              />
            ) : modValues.modName === "trial_history" ? (
              <ThreedayTrialHistory
                rowData={modValues.rowData}
                userInfoData={userInfoData}
              />
            ) : null}
          </div>
        </Modal>

        <Row>
          <Col>
            <PageHeadingNew
              heading="3 day PT trial"
              subheading="manage, track and re-assign PT trial"
              onReload={() => {
                getStats(filters);
                getThreeDayTrialMembers(filters);
              }}
            />
          </Col>
        </Row>
        <br />

        <Row>
          <Col>
            <Tabs defaultIndex={0}>
              <TabList>
                <Tab>3 Day PT Trial</Tab>
                <Tab>Ongoing PT Details</Tab>
                <Tab>Trainer Report</Tab>
              </TabList>

              <TabPanel>
                <Row>
                  <Col>
                    <CmnFilters
                      from={"three-day-trial"}
                      userInfoData={userInfoData}
                      onClickReset={onResetFilters}
                      filters={allFilters}
                      setFilters={setAllFilters}
                      onClickSearch={onClickSearch}
                      searchFilterApplied={searchFilterApplied}
                      searchPlaceHolder="Search by name, mobile, email..."
                      isLoading={threeDayPTTrialLoading}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <ThreeDayTrialStats userInfoData={userInfoData} filters={filters} />
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <ThreeDayPTMembers
                      isPage={isPage}
                      setIsPage={setIsPage}
                      pageLimit={pageLimit}
                      setPageLimit={setPageLimit}
                      setModValues={setModValues}
                    />
                  </Col>
                </Row>
              </TabPanel>

              <TabPanel>
                <Row>
                  <Col>
                    <ThreeDayMemberDetailsTab userInfoData={userInfoData} />
                  </Col>
                </Row>
              </TabPanel>

              <TabPanel>
                <Row>
                  <Col>
                    <TrainerTrialReport userInfoData={userInfoData} />
                  </Col>
                </Row>
              </TabPanel>
            </Tabs>
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default ThreeDayPTTrialStructure;
